import Lottie from 'lottie-react';
import { Button } from '@/shared/components/Buttons';
import { ButtonVariant } from '@/shared/components/Buttons/types';
import { useViewErrorScreen } from '@/epics/subscriptionManagment/hooks/useViewErrorScreen';
import { VIEW_SERVICE_REQUEST_LABELS as L } from '../../constants/labels';

const ViewServiceRequestErrorScreen = () => {
  const { animationData, isLoading, handleReload } = useViewErrorScreen();

  return (
    <div
      className="flex flex-col items-center gap-5 justify-center h-screen bg-white"
      data-testid="view-sr-error-screen"
    >
      {animationData && !isLoading ? (
        <Lottie
          animationData={animationData}
          loop={false}
          style={{ width: '30%', height: '30%' }}
        />
      ) : (
        <div
          className="flex items-center justify-center"
          style={{ width: '50%', height: '50%' }}
        >
          <div className="text-gray-400">Ładowanie...</div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-1">
        <h1
          className="text-bodyLarge font-medium text-center"
          style={{ color: '#474A4C' }}
        >
          {L.VIEW_ERROR_TITLE}
        </h1>
        <p className="text-bodyLarge text-on-surface-variant text-center">
          {L.VIEW_ERROR_DESCRIPTION}
        </p>
      </div>
      <Button
        label={L.VIEW_ERROR_RELOAD}
        className="hover:cursor-pointer"
        variant={ButtonVariant.Primary}
        size="Small"
        onClick={handleReload}
      />
    </div>
  );
};

export default ViewServiceRequestErrorScreen;
